import type { RootState } from '~/reducers';
import type { CoupleVendorTeamState } from '~/reducers/couples/vendorTeamReducer';

export const getVendorTeam = (state: RootState): CoupleVendorTeamState => state.couples?.vendorTeam;
